import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const RTOServiceOffered = () => {
  return (
    <>
      <div className="col-md-12 mb80">
        <h2 className="text-center mb40 mt-0">
          Services Offered by Regional Transport Offices
        </h2>
        <p>
          Any Regional Transport Office (RTO) across various cities, states or
          union territories in India have certain sets of functions that they
          are deemed to carry out. The main functions of an RTO are three-fold:
        </p>
        <ul className="list">
          <li>
            To ensure that the provisions of all the rules and regulations
            stated under the Motor Vehicles Act, 1988, the Central Motor
            Vehicles Rules, 1989 and the state motor vehicles guidelines are
            properly enforced.
          </li>
          <li>
            To levy and collect tax according to the provisions of the Motor
            Vehicles Act, 1988.
          </li>
          <li>
            To facilitate the development and growth of road transportation by
            managing respective permits.
          </li>
        </ul>
        <p className="mb-0">
          In order to comply with the functional requirements mentioned above,
          all RTOs perform the following main activities, as per the vehicles
          act:
        </p>
      </div>
      <div className="col-md-12 mb80">
        <div className="clearfix d-block d-md-flex services-rto">
          <div className="px-3 br1-grey text-center w20">
            <StaticImage src="../images/rto-images/mvr.svg" alt="mvr" />
            <h3 className="f16 fw7 my-3 fs-6">Motor Vehicle Registration</h3>
            <p>
              This includes issuing and renewing registration certificates for
              motor vehicles, transfer of ownership of the vehicle, change in
              registration details, hypothecation removal and issuing fitness
              certificate to the vehicle
            </p>
          </div>
          <div className="px-3 br1-grey text-center w20">
            <StaticImage src="../images/rto-images/mvtc.svg" alt="mvtc" />
            <h3 className="f16 fw7 my-3 fs-6">Motor Vehicle Tax Collection</h3>
            <p>
              This includes collection of Motor Vehicle Tax, or Road Tax, as per
              the Motor Vehicles Act, 1988, conducting any motor department’s
              action cases and collection of vehicle inspection fee
            </p>
          </div>
          <div className="px-3 br1-grey text-center w20">
            <StaticImage src="../images/rto-images/idl.svg" alt="idl" />
            <h3 className="f16 fw7 my-3 fs-6">Issuance of Driving Licence</h3>
            <p>
              This includes issuing a learner’s permit and subsequently a
              driving licence, conducting driving tests, renewal or duplication
              of driving licence (in case of loss or theft), issuing licence for
              driving instructors, conductors for commercial vehicles and for
              professional motor vehicles driving schools
            </p>
          </div>
          <div className="px-3 br1-grey text-center w20">
            <StaticImage src="../images/rto-images/vmi.svg" alt="vmi" />
            <h3 className="f16 fw7 my-3 fs-6">
              Vehicle’s Mechanical Inspection
            </h3>
            <p>
              This includes vehicle inspection for fitness certification, for
              giving clearance to accidental vehicles, and validity check for
              insurance and Pollution Under Control (PUC) certificate
            </p>
          </div>
          <div className="px-3 text-center w20">
            <StaticImage src="../images/rto-images/ip.svg" alt="ip" />
            <h3 className="f16 fw7 my-3 fs-6">Issuance of Permits</h3>
            <p>
              This includes issuing various tourist and transportation permits
              such as International Driving Permit, inter-state and national
              permits for commercial vehicles, permits for passenger carrying
              vehicles and school buses, and All India Tourist Vehicle
              Authorisation and Permit
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default RTOServiceOffered
